/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import {debounce} from 'ts-debounce';
import _ from 'underscore';

import Col from 'ui-library/bs/Col';
import Row from 'ui-library/bs/Row';
import BenchlingIcon, {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';
import Modal from 'ui-library/modals/Modal';
import * as net from 'util/Net';

interface AttachOption {
  type?: string;
  title?: string;
  icon: BenchlingIconName;
  preview: {
    getName: any;
  };
}

interface Props {
  fileId: string;
  options: Array<AttachOption>;
  insertItemHandler: (...args: Array<any>) => any;
  closeModalHandler: (...args: Array<any>) => any;
  attached: any;
  itemDetachHandler: any;
}

interface State {
  results: Array<any> | null;
  error: boolean;
  linkType: string;
  attached: any;
  query?: string;
}

class AttachModal extends React.Component<Props, State> {
  _isMounted: any;
  _lastQuery: any;
  state: State = {
    results: null,
    error: false,
    linkType: 'model',
    attached: this.props.attached,
  };
  queryRef = React.createRef<HTMLInputElement>();

  doSearch = (): void => {
    // Since doSearch is sometimes debounced, the attach modal might have closed already.
    if (!this._isMounted) {
      return;
    }

    const query = (ReactDOM.findDOMNode(this.queryRef.current) as HTMLInputElement).value;
    const type = $(ReactDOM.findDOMNode(this)!).find('[name="link-type"]:checked').val();
    this._lastQuery = query;
    net
      .getJSON(`/1/api/files/link-search?fromFileId=${this.props.fileId}`, {
        limit: 5,
        query,
        type,
      })
      .done((results: Array<any>) => {
        if (this._isMounted && query === this._lastQuery) {
          this.setState({query, results, error: false});
        }
      })
      .fail(() => {
        if (this._isMounted && query === this._lastQuery) {
          this.setState({query, results: null, error: true});
        }
      });
  };

  focusAndSearch = (): void => {
    this.setState({
      linkType: $(ReactDOM.findDOMNode(this)!).find('[name="link-type"]:checked').val(),
    });

    // TODO(T1201) For now, don't focus since it messes with the tooltip. For some reason,
    // if we focus this element, then the mouseout event on the tooltip for
    // the attach button never gets called.
    // ReactDOM.findDOMNode(@refs.query).focus()

    this.doSearch();
  };

  componentDidMount(): void {
    this._isMounted = true;
    this.focusAndSearch();
  }

  componentWillUnmount(): void {
    this._isMounted = false;
  }

  updateAttached = (attached: any): void => {
    this.setState({attached});
  };

  renderLabel = ({type, icon, title}: any): JSX.Element => (
    <label key={type}>
      <input
        ref={`__${type}Option`}
        type="radio"
        name="link-type"
        defaultChecked={type === this.state.linkType}
        value={type}
        onChange={this.focusAndSearch}
      />
      <span>
        <span className="add-note-icon">{icon != null ? <BenchlingIcon icon={icon} /> : undefined}</span>
        <span className="u-small-spacing-left">{title}</span>
      </span>
    </label>
  );

  save = (): void => {
    if (this.state.attached) {
      this.props.insertItemHandler(
        this.state.attached.type,
        this.state.attached.item_id,
        this.state.attached.item
      );
      this.props.closeModalHandler();
    } else {
      this.props.itemDetachHandler();
    }
  };

  getPreviewCls = (type: any): AttachOption['preview'] => _.findWhere(this.props.options, {type})!.preview;

  render(): JSX.Element {
    return (
      <Modal
        title="Attach feature to note"
        onRequestClose={this.props.closeModalHandler}
        onRequestSubmit={this.save}
        buttons={[{text: 'Save', submit: true}]}
      >
        <div className="add-note">
          <div className="u-spacing-bottom">
            <Row>
              <Col sm={3}>
                <label className="pull-right u-tiny-spacing-top">Selected</label>
              </Col>
              {this.state.attached != null ? (
                <Col sm={9}>
                  <BenchlingIcon
                    icon="trash-can"
                    className="pull-right u-danger-pointer u-tiny-spacing-top"
                    onClick={this.updateAttached.bind(null, null)}
                  />
                  <div className="link-item">
                    <BenchlingIcon
                      icon={this.state.attached.type}
                      className="u-small-space-right link-icon"
                      style={{color: this.state.attached.item.color || 'black'}}
                    />
                    <span className="link-name">
                      {(typeof this.getPreviewCls(this.state.attached.type).getName === 'function'
                        ? this.getPreviewCls(this.state.attached.type).getName(this.state.attached.item)
                        : undefined) || this.state.attached.item.name}
                    </span>
                  </div>
                </Col>
              ) : (
                <Col sm={9}>
                  {
                    // Keep the spacing styling for link items so the row doesn't shift when you switch between
                    // attachment and no attachment.
                    <div className="link-item">
                      <div className="link-name">None</div>
                    </div>
                  }
                </Col>
              )}
            </Row>
          </div>
          <Row>
            <Col sm={3}>
              <label className="pull-right">Filter by type</label>
              <div className="add-note-container u-small-spacing-top">
                {this.renderLabel({type: 'model', title: 'All', icon: null})}
                {Array.from(this.props.options).map((plugin) => this.renderLabel(plugin))}
              </div>
            </Col>
            <Col sm={9}>
              <input
                autoFocus={true}
                placeholder="Search for a sequence feature to link"
                type="text"
                ref={this.queryRef}
                onInput={debounce(this.doSearch, 500)}
              />
              <ol className="link-suggestions u-small-spacing-top">
                {(() => {
                  if (this.state.error) {
                    return (
                      <li className="link-item link-item--message alert-danger">
                        <span className="link-icon" />
                        <span className="link-name">An error occurred. Try your search again.</span>
                      </li>
                    );
                  } else if (this.state.results != null) {
                    if (this.state.results.length) {
                      return (() => {
                        const result1 = [];
                        for (const result of Array.from(this.state.results)) {
                          const active =
                            this.state.attached != null &&
                            result.type === this.state.attached.type &&
                            result.item_id === this.state.attached.item_id;
                          if (active) {
                            result1.push(
                              <li key={`${result.type}${result.item_id}`} className="attached-item active">
                                {/* @ts-expect-error PreviewPluginFactory does not define a type for this */}
                                {React.createElement(this.getPreviewCls(result.type), {
                                  item: result.item,
                                  showOpenLink: false,
                                  placeholder: false,
                                  taskId: null,
                                  task: null,
                                })}
                              </li>
                            );
                          } else {
                            result1.push(
                              <li
                                key={`${result.type}${result.item_id}`}
                                className="link-item"
                                onClick={this.updateAttached.bind(null, result)}
                              >
                                <BenchlingIcon
                                  icon={result.type}
                                  className="link-icon"
                                  style={{color: result.color}}
                                />
                                <span className="link-name">{result.name}</span>
                              </li>
                            );
                          }
                        }
                        return result1;
                      })();
                    } else if (this.state.query!.length) {
                      return (
                        <li className="link-item link-item--message alert-warning">
                          <span className="link-icon" />
                          <span className="link-name">No items matched the search query.</span>
                        </li>
                      );
                    }
                  }
                  return null;
                })()}
              </ol>
            </Col>
          </Row>
          <p className="help-block u-no-spacing-bottom u-spacing-top">
            {'You can also drag and drop files from the file browser at the left or your computer '}
            into the note.
          </p>
        </div>
      </Modal>
    );
  }
}

export default AttachModal;
